import { Component, Input } from '@angular/core';

import { HeaderOptionsComponent } from '../header-options.component';

@Component({
  selector: 'customer-header-options-item',
  templateUrl: './header-options-item.component.html',
  styleUrls: ['./header-options-item.component.scss'],
})
export class HeaderOptionsItemComponent<T> {
  @Input() value?: T;
  @Input() accent = false;

  get active(): boolean {
    return this.value === this.headerOptions.value;
  }

  constructor(readonly headerOptions: HeaderOptionsComponent<T>) {
  }

  click(): void {
    if (this.active || !this.headerOptions.interactive) {
      return;
    }

    this.activate();
  }

  activate(): void {
    this.headerOptions.value = this.value;
    this.headerOptions.valueChange.emit(this.value);
  }
}
